import { z } from 'zod';
import { CarrierOptionSchema } from './carriers';

// The carriers that have delivered at one building, on
// `GET /app_service/panel/v1/locations/<location_id>/carriers`.
//
// Delivered as requested (AS-041, CBX-11167) and verified against dev.
//
// The envelope follows its delivered siblings (`locations?q=`) rather than the DRF cursor
// convention: bare `{count, results}`, no cap, so `count` and the list's length agree by contract.
//
// `next` is a SCHEMA constraint and deliberately not a runtime check: present-and-null parses,
// absent parses, and any cursor value fails the parse. A paginated answer must fail loud, because a
// dropped option reads to the agent as «this carrier does not deliver here» — a wrong answer
// indistinguishable from a right one.
export const LocationCarriersResponseSchema = z.object({
  count: z.number(),
  results: z.array(CarrierOptionSchema),
  next: z.null().optional(),
});

export type LocationCarriersResponse = z.infer<typeof LocationCarriersResponseSchema>;
